module.exports = __webpack_public_path__ + "img/video-camera.003da2f7.svg";